import { makeStyles } from '@material-ui/core';

const useRadioButtonStyles = makeStyles({
  root: {
    '&.MuiIconButton-root': {
      padding: '5px',
      paddingLeft: '10px',
    },
  },
});

export { useRadioButtonStyles };
